import React from "react";
import LabeledValue from "./LabeledValue";
import { CARD_SURFACE, ETA_PURPLE } from "./constants";

// LabeledValue in a hairline-bordered box (Fleet / Total Trips).
const InfoBox = ({ label, value }) => (
  <div className="self-start border border-gray-500 flex items-center" style={{ borderRadius: 8, padding: "8px 16px", minHeight: 56 }}>
    <LabeledValue label={label} value={value} />
  </div>
);

// Driver name. Pure CSS: wraps to a second line as the card narrows, then
// truncates with an ellipsis only past two lines. `whiteSpace: normal` is set
// explicitly to override the `white-space: nowrap` inherited from the page's
// `.custom-scrollbar` container. (A JS font-shrink was attempted but its width
// measurement is unreliable inside this flex/grid layout, so this reliable CSS
// behaviour is used instead — the extreme name length here won't occur in prod.)
const BioCard = ({ driver, totalGroupedTrips }) => (
  <div className="bg-white flex flex-col justify-between overflow-hidden" style={{ ...CARD_SURFACE, padding: 20, minWidth: 0 }}>
    <div style={{ minWidth: 0 }}>
      <h3
        className="font-bold"
        style={{
          fontSize: 32,
          color: ETA_PURPLE,
          lineHeight: 1.15,
          whiteSpace: "normal",
          overflowWrap: "break-word",
          wordBreak: "break-word",
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}>
        {driver.full_name || "—"}
      </h3>
      <p style={{ fontSize: 18, marginTop: 6, color: "#656C7B" }}>
        ID: {driver.employee_id || driver.id || "—"}
      </p>
    </div>
    <div className="flex flex-col" style={{ gap: 8 }}>
      <InfoBox label="Fleet" value={driver.fleet || "—"} />
      <InfoBox label="Total Trips" value={totalGroupedTrips} />
    </div>
  </div>
);

export default BioCard;
